/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import Modal from "react-modal";
import UI from "@mile-meeting/mile-ui";
import { Spinner } from "./Spinner";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    backgroundColor: "rgba(0, 0, 0, 0)",
    border: "none",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1010,
  },
};

Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  title?: string | JSX.Element;
  isShowWaitingText?: boolean;
};

export default function LoadingModal(props: Props) {
  const { modalIsOpen, title, isShowWaitingText = true } = props;
  if (modalIsOpen) {
    return (
      <Modal isOpen={modalIsOpen} style={modalStyle}>
        <Container>
          <Spinner />
          <ContentContainer>
            <UI.Typography color="var(--global-color-common-100)" type="headline01" fontStyle="bold">
              {title ?? ""}
            </UI.Typography>
            {isShowWaitingText && (
              <UI.Typography color="var(--global-color-common-100)" type="body02 normal">
                잠시만 기다려주세요.
              </UI.Typography>
            )}
          </ContentContainer>
        </Container>
      </Modal>
    );
  } else return null;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
